// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__3Nhb_","alert":"SettungsInbox_alert__38Pp0"};